import { Playground, Props } from 'docz';
import { Spacing } from "../../../../../documentation/styling/helpers";
import * as React from 'react';
export default {
  Playground,
  Props,
  Spacing,
  React
};